import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-todays-sales-card',
  templateUrl: './todays-sales-card.component.html',
  styleUrls: ['./todays-sales-card.component.scss'],
})
export class TodaysSalesCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public salesToday: number = 0;
  public salesTodayPositive: boolean = false;
  public salesTodayPercent: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getSalesToday()
      .then((value) => {
        this.salesToday = value.currentValue;
        this.salesTodayPositive = value.percentLastPeriod >= 0 ? true : false;
        this.salesTodayPercent = value.percentLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
